import { useEffect, useState } from "react";

/**
 * @template T
 * @param {() => Promise<import("axios").AxiosResponse<T>>} apiFunction
 * @param {T?} initialValue
 * @returns {[T, "loading" | "success" | "error", (value: T | () => T) => void]}
 */
export default function useAxiosData(apiFunction, initialValue) {
    const [data, setData] = useState(initialValue);
    const [status, setStatus] = useState("loading");

    useEffect(() => {
        (async () => {
            try {
                setData((await apiFunction()).data);
                setStatus("success");
            } catch (error) {
                console.error('Error fetching data:', error);
                setStatus("error");
            }
        })();
    }, []);

    return [data, status, setData];
}